import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { groupNodeCreateStartAtom } from "../diagramming";
import { isViewOnlyModeAtom } from "../permissions";

import { sidebarOpenNodeIdAtom } from "./sidebarOpenNodeIdAtom";
import { isOnlyNodeSelectedAtomFamily } from "./isOnlyNodeSelectedAtomFamily";

export const isNodeInEditModeAtomFamily = atomFamily((id: string) => {
  const isNodeInEditModeAtom = atom((get) => {
    const isViewOnlyMode = get(isViewOnlyModeAtom);
    const groupNodeCreateStart = get(groupNodeCreateStartAtom);
    const isOnlyNodeSelected = get(isOnlyNodeSelectedAtomFamily(id));
    const sidebarOpenNodeId = get(sidebarOpenNodeIdAtom);
    const isInEditMode =
      !isViewOnlyMode &&
      !groupNodeCreateStart &&
      isOnlyNodeSelected &&
      id === sidebarOpenNodeId;
    return isInEditMode;
  });
  return isNodeInEditModeAtom;
});
